<template>
  <div class="vw100 bg-w pt77 pb75 minh530 column a-center">
    <div class="w-per62_5 row a-center">

      <div class="flex1">
        <div class="ft36 font-Regular c-00903B">{{ $t('关于我们') }}</div>
        <div class="mt25 w-per100 word-break ft16 font-Regular lh30 aboutBox"></div>
        <div class="w200 h50 mt42 row flex-center ft14 font-Regular c-00903B bd-00903B pointer" @click="toPath">
          <span>{{ $t('查看详细') }}</span>
          <span class="ml38">→</span>
        </div>
      </div>

      <div class="w-per42 ml36">
        <img
          loading="lazy"
          class="w-per100"
          referrerpolicy="no-referrer"
          :src="getImageUrl(index_about.img)"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default{
  data(){
    return {
      
    };
  },
  computed: {
    ...mapGetters({
      index_about:'indexAbout',
    })
  },
  watch:{
    index_about:{
      handler:function(newVal){
        this.handleAbout();
      }
    }
  },
  mounted(){
    this.handleAbout();
  },
  methods:{
    toPath(){
      this.$router.push({
        path: "/Intro",
      })
    },
    handleAbout(){
      let el = document.querySelector('.aboutBox');
      el.innerHTML = this.index_about.index_intro;
    },
  },
}
</script>

<style scoped lang="scss">

</style>